module.exports = __webpack_public_path__ + "assets/img/facergt-offlinergb.1d16ac06.png";